import { animated, useSpring } from "@react-spring/web";
import { Button, Typography } from "design_system/src";
import React, { useEffect, useState } from "react";
import ReactGA from "react-ga4";
import { Link } from "react-router-dom";

const CTAs: React.FC = () => {
  const [currentNameIndex, setCurrentNameIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  const phrases = [
    "trabajar mejor",
    "ser independiente",
    "cumplir tus metas",
    "moverte sin límites",
    "sentirte libre",
    "ahorrar más",
  ];

  const slideAnimation = useSpring({
    from: { transform: "translateY(100%)", opacity: 0 },
    to: { transform: "translateY(0%)", opacity: 1 },
    config: { tension: 300, friction: 30 },
    reset: true,
  });

  const exitAnimation = useSpring({
    from: { transform: "translateY(0%)", opacity: 1 },
    to: { transform: "translateY(-100%)", opacity: 0 },
    config: { tension: 300, friction: 30 },
    reset: true,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setIsAnimating(true);
      setTimeout(() => {
        setCurrentNameIndex((prevIndex) => (prevIndex + 1) % phrases.length);
        setIsAnimating(false);
      }, 300);
    }, 3000);

    return () => clearInterval(interval);
  }, [phrases.length]);

  const handleFFButton = () => {
    ReactGA.event("CTA_Home_go_to_ff", {
      category: "Home",
      label: "click in CTA to go to financial form",
    });
  };

  const handleCatalogButton = () => {
    ReactGA.event("CTA_Home_go_to_catalog", {
      category: "Home",
      label: "click in CTA to go to catalog",
    });
  };

  return (
    <section className="dso_container p_y_md">
      <div className="p_y_xxxl">
        <Typography
          scale="heading1"
          scaleMobile="heading2"
          weight="600"
          className="text_center w_100_per display_flex flex_align_start flex_justify_center flex_gap_sm flex_col_mobile flex_align_center_mobile"
        >
          Estrena moto para
          <div className="text_primary_300 text_left text_center_mobile" style={{
            position: "relative",
            height: "1.4em",
            width: `${phrases[currentNameIndex].length * 25}px`,
            overflow: "hidden",
          }}>
            <animated.span
              style={{
                ...(isAnimating ? exitAnimation : slideAnimation),
                position: "absolute",
                width: "100%",
                display: "block",
                left: 5,
              }}
            >
              {phrases[currentNameIndex]}
            </animated.span>
          </div>
        </Typography>
      </div>

      <div className="display_flex flex_col flex_align_center p_b_xxxl">
        <Typography
          weight="400"
          scale="heading4"
          scaleMobile="large"
          className="m_b_lg"
        >
          Elige tu moto. Financia fácil. Acelera tus sueños.
        </Typography>

        <div className="w_100_per_mobile display_flex flex_col_mobile flex_gap_md">
          <Link to="/financia-tu-moto">
            <Button className="w_100_per_mobile" onClick={handleFFButton}>
              <Typography
                scale="large"
                weight="600"
              >
                Solicita tu crédito ya
              </Typography>
            </Button>
          </Link>
          <Link to="/catalogo">
            <Button className="w_100_per_mobile" variant="outline" onClick={handleCatalogButton}>
              <Typography
                scale="large"
                weight="600"
              >
                Ver catálogo de motos
              </Typography>
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CTAs;
